import { TypeEnum } from "../../shared/widgets/Form/enums/TypeEnum";
import { IForm } from "../../shared/widgets/Form/models/Form.model";

export const KnowledgeBaseForm: IForm[] = [
  {
    label: "Knowledge Base ID",
    field: "name",
    value: "",
    type: TypeEnum.Input,
  },
  {
    label: "Description",
    field: "description",
    value: "",
    type: TypeEnum.Description,
  },
  {
    label: "Vector Store",
    field: "vectorStore",
    value: "",
    options: [
      { label: "MongoDB", value: "mongodb" },
      { label: "ChromaDB", value: "chromadb" },
    ],
    type: TypeEnum.Dropdown,
  },
  {
    label: "Connection String",
    field: "connectionString",
    value: "",
    type: TypeEnum.Input,
  },
  {
    label: "Index Name",
    field: "indexName",
    value: "",
    type: TypeEnum.Input,
  },
  {
    label: "Database",
    field: "database",
    value: "",
    type: TypeEnum.Input,
  },
  {
    label: "Collection",
    field: "collection",
    value: "",
    type: TypeEnum.Input,
  },
  {
    label: "Content Field",
    field: "contentField",
    value: "",
    type: TypeEnum.Input,
  },
  {
    label: "Search Type",
    field: "searchType",
    value: "",
    options: [
      { label: "Semantic", value: "semantic" },
      { label: "Keyword", value: "keyword" },
    ],
    type: TypeEnum.Dropdown,
  },
];
